import type { SxProps } from "@mui/material"

export const getMonitoringTableSx = (theme: any): SxProps => {
    const neutral = theme.palette.neutral
    const divider = theme.palette.divider ?? "rgba(255, 255, 255, 0.12)"

    return {
        minWidth: 720,
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: 0,
        "& .MuiTableCell-root": {
            borderBottom: `1px solid ${divider}`,
            borderRight: "none",
            borderLeft: "none",
            py: 1.25,
            px: 1.5,
            fontSize: theme.typography.body2?.fontSize ?? "0.875rem",
            lineHeight: theme.typography.body2?.lineHeight ?? 1.43,
            color: theme.palette.text?.primary ?? neutral.lighter,
        },
        "& .MuiTableHead-root .MuiTableCell-root": {
            backgroundColor: neutral.darker,
            borderBottom: `1px solid ${divider}`,
            py: 1,
            fontWeight: 600,
            color: theme.palette.text?.secondary ?? neutral.light,
            fontSize: theme.typography.caption?.fontSize ?? "0.75rem",
            textTransform: "none",
        },
        "& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root": {
            borderBottom: "none",
        },
        "& .MuiTableBody-root .MuiTableRow-root:hover .MuiTableCell-root": {
            backgroundColor: neutral.darker,
        },
        "& .MuiTableBody-root .MuiTableRow-root:nth-of-type(even) .MuiTableCell-root": {
            backgroundColor: neutral.darkest,
        },
        "& .MuiTableBody-root .MuiTableRow-root:nth-of-type(even):hover .MuiTableCell-root": {
            backgroundColor: neutral.darker,
        },
    }
}

export const getMonitoringTableContainerSx = (theme: any): SxProps => {
    const neutral = theme.palette.neutral
    const divider = theme.palette.divider ?? "rgba(255, 255, 255, 0.12)"
    const radius = theme.shape?.border?.general?.radius?.[8] ?? 8

    return {
        overflowX: "auto",
        maxWidth: "100%",
        borderRadius: radius,
        border: `1px solid ${divider}`,
        backgroundColor: neutral.darkest,
    }
}
